export default __webpack_public_path__ + "static/media/squirrel.5220440b.png";